<template>
  <div class="package-url-input">
    <el-input
      :value="value"
      :placeholder="placeholder"
      clearable
      @input="$emit('input', $event)"
    >
      <el-button slot="append" :loading="uploading" @click="pickFile">上传文件</el-button>
    </el-input>
    <input
      ref="fileInput"
      type="file"
      :accept="accept"
      style="display: none"
      @change="onFileSelected"
    />
    <p v-if="tip" class="tips">{{ tip }}</p>
  </div>
</template>

<script>
import FileApi from '@/api/file.js';

export default {
  name: 'PackageUrlInput',
  props: {
    value: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: '.apk,.wgt'
    },
    ext: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '支持上传文件自动回填，或手动填写外链地址'
    },
    tip: {
      type: String,
      default: ''
    },
    emitMeta: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploading: false
    };
  },
  methods: {
    pickFile() {
      if (this.uploading) {
        return;
      }
      const input = this.$refs.fileInput;
      if (input) {
        input.value = '';
        input.click();
      }
    },
    onFileSelected(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) {
        return;
      }
      const name = (file.name || '').toLowerCase();
      const expectExt = (this.ext || '').toLowerCase();
      if (expectExt && !name.endsWith('.' + expectExt)) {
        this.$message.warning('请选择 .' + expectExt + ' 格式文件');
        return;
      }
      this.uploadFile(file);
    },
    uploadFile(file) {
      const self = this;
      self.uploading = true;
      const formData = new FormData();
      formData.append('iFile', file);
      formData.append('group_id', -1);
      formData.append('file_type', 'app_package');

      FileApi.uploadFile(formData)
        .then(res => {
          self.uploading = false;
          const body = res.data || {};
          if (body.code !== 1 || !body.data) {
            self.$message.error(body.msg || '上传失败');
            return;
          }
          const data = body.data;
          const url = data.file_path || '';
          if (!url) {
            self.$message.error('上传成功但未返回文件地址');
            return;
          }
          self.$emit('input', url);
          if (self.emitMeta) {
            self.$emit('meta', {
              md5: data.file_md5 || '',
              size: data.file_size || 0
            });
          }
          self.$message.success('上传成功，地址已回填');
        })
        .catch(() => {
          self.uploading = false;
          self.$message.error('上传失败，请稍后重试');
        });
    }
  }
};
</script>

<style scoped>
.tips {
  color: #999;
  font-size: 12px;
  line-height: 1.4;
  margin: 4px 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/file/PackageUrlInput.vue